import { render, staticRenderFns } from "./InvestmentData.vue?vue&type=template&id=4291614c&"
import script from "./InvestmentData.vue?vue&type=script&lang=js&"
export * from "./InvestmentData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports